export default {
    BASE_URL: 'BASE_URL_STATIQ' + '/',
    BASE_URL_ECOM: 'BASE_URL_ECOM' + '/'
}
